import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container, FormFeedback } from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import debounce from 'lodash.debounce';
import { FormattedMessage, useIntl } from 'react-intl';
import PaletizadosTable from "../Paletizados/PaletizadosTable"
import { PaletizadosView } from "./PaletizadosView"
import { PaletizadosDelete } from "./PaletizadosDelete"
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';

import { Breadcrumbs } from '../General/Breadcrumbs';
import authService from '../api-authorization/AuthorizeService'

export class Paletizados_Index extends Component {
    static displayName = Paletizados_Index.name;
    constructor(props) {
        super(props);
        var rawUrl = window.location.toString();
        var contenedorSemanal_Id = rawUrl.split("ContenedoresSemanales/")[1].split("/")[0];
        this.state = {
            data: [],
            loading: true,
            modalState: false,
            errorModalsate: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            model: {
                contenedorSemanal_Id: contenedorSemanal_Id,
                etiquetaCore_Id: 0,
                calibre_Id: 0,
                cajasPorPaleta_Id: 0,
                carton: "",
                colilla: "",
                fechaDeCosecha: new Date().toISOString().substring(0, 10),
                fechaDeEmpaque: new Date().toISOString().substring(0, 10),
                codigoTMU: "",
                comentarios: "",
                finca: "",
                errorModalText: "",
            },
            contenedorSemanal: {},
            etiquetasCore: [],
            calibres: [],
            cajasPorPaleta: [],
        };
        this.state.modelValidation = {
            etiquetaCore_Id: this.state.model.etiquetaCore_Id != 0,
            calibre_Id: this.state.model.calibre_Id != 0,
            cajasPorPaleta_Id: this.state.model.cajasPorPaleta_Id != 0,
            codigoTMU: this.state.model.codigoTMU != ""
        }
        this.load_contenedorSemanal = this.load_contenedorSemanal.bind(this);
        this.load_etiquetasCore = this.load_etiquetasCore.bind(this);
        this.load_calibres = this.load_calibres.bind(this);
        this.load_cajasPorPaleta = this.load_cajasPorPaleta.bind(this);
        this.load_contenedores = this.load_contenedores.bind(this);
        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.errorModalToggle = this.errorModalToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        //this.validate = debounce(this.validate, 500)
        this.clean_onclick = this.clean_onclick.bind(this);
        this._handleKeyDown = this._handleKeyDown.bind(this);

        this.inputCodigoTMU = React.createRef();
    }
    async validate() {
        //const token = await authService.getAccessToken();
        //var model = this.state.model;
        //model.fechaDeCosecha = model.fechaDeCosecha != "" ? model.fechaDeCosecha : null;
        //model.fechaDeEmpaque = model.fechaDeEmpaque != "" ? model.fechaDeEmpaque : null;
        //const data = JSON.stringify(model);
        //const response = await fetch('api/paletizados/validate', {
        //    method: 'POST',
        //    headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        //    body: data
        //});
        //if (response.ok) {
        //    var validations = await response.json();
        //    var modalIsValid = !Object.keys(validations).some(function (val) {
        //        return validations[val] == false;
        //    });
        //    this.setState({
        //        modelValidation: validations,
        //        modalIsValid: modalIsValid
        //    }, () => {
        //        /*this.props.setModalBodyState(this.state);*/
        //    });
        //}
        var modelValidation = {
            etiquetaCore_Id: this.state.model.etiquetaCore_Id != 0,
            calibre_Id: this.state.model.calibre_Id != 0,
            cajasPorPaleta_Id: this.state.model.cajasPorPaleta_Id != 0,
            codigoTMU: this.state.model.codigoTMU != "",
            fechaDeCosecha: this.state.model.fechaDeCosecha != "" && this.state.model.fechaDeCosecha,
            fechaDeEmpaque: this.state.model.fechaDeEmpaque != "" && this.state.model.fechaDeEmpaque
        }
        var modalIsValid = !Object.keys(modelValidation).some(function (val) {
            return modelValidation[val] == false;
        });
        this.setState({ modelValidation: modelValidation, modalIsValid: modalIsValid }, async () => {

        });
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }
    errorModalToggle() {
        this.setState({
            errorModalsate: !this.state.errorModalsate
        });
    }

    renderTable() {
        var hideCalibre = this.state.contenedorSemanal.producto == "Banano";
        hideCalibre = false;
        return (
            <div  >
                <Row>
                    <Form >
                        <Row>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="etiquetaCore_Id">
                                        <FormattedMessage id='EtiquetaCore' />
                                    </Label>
                                    <Input
                                        id="etiquetaCore_Id"
                                        name="etiquetaCore_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        valid={this.getValidationValue(this.state.modelValidation.etiquetaCore_Id)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.etiquetaCore_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.etiquetasCore.map(etiquetaCore => etiquetaCore.etiquetaCore_Id == this.state.model.etiquetaCore_Id ? (
                                            <option value={etiquetaCore.etiquetaCore_Id} selected>
                                                {etiquetaCore.nombre}
                                            </option>
                                        ) : (<option value={etiquetaCore.etiquetaCore_Id}>{etiquetaCore.nombre}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.etiquetaCore_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="carton">
                                        <FormattedMessage id='Carton' />
                                    </Label>
                                    <FormattedMessage id='Carton'>
                                        {(placeholder) =>
                                            <Input
                                                id="carton"
                                                name="carton"
                                                //placeholder={placeholder}
                                                type="text"
                                                value={this.state.model.carton}
                                                readOnly
                                            />
                                        }
                                    </FormattedMessage>

                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="colilla">
                                        <FormattedMessage id='Colilla' />
                                    </Label>
                                    <FormattedMessage id='Colilla'>
                                        {(placeholder) =>
                                            <Input
                                                id="colilla"
                                                name="colilla"
                                                //placeholder={placeholder}
                                                type="text"
                                                value={this.state.model.colilla}
                                                readOnly
                                            />
                                        }
                                    </FormattedMessage>

                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="calibre_Id">
                                        <FormattedMessage id='Tipo de fruta' />
                                    </Label>
                                    <Input
                                        disabled={hideCalibre}
                                        id="calibre_Id"
                                        name="calibre_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        valid={!hideCalibre && this.getValidationValue(this.state.modelValidation.calibre_Id)}
                                        invalid={!hideCalibre && !this.getValidationValue(this.state.modelValidation.calibre_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.calibres.map(calibre => calibre.calibre_Id == this.state.model.calibre_Id ? (
                                            <option value={calibre.calibre_Id} selected>
                                                {calibre.calibre}
                                            </option>
                                        ) : (<option value={calibre.calibre_Id}>{calibre.calibre}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.calibre_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="cajasPorPaleta_Id">
                                        <FormattedMessage id='Cajas por paleta' />
                                    </Label>
                                    <Input
                                        id="cajasPorPaleta_Id"
                                        name="cajasPorPaleta_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        valid={this.getValidationValue(this.state.modelValidation.cajasPorPaleta_Id)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.cajasPorPaleta_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.cajasPorPaleta.map(cajasPorPaleta => cajasPorPaleta.cajasPorPaleta_Id == this.state.model.cajasPorPaleta_Id ? (
                                            <option value={cajasPorPaleta.cajasPorPaleta_Id} selected>
                                                {cajasPorPaleta.cantidad}
                                            </option>
                                        ) : (<option value={cajasPorPaleta.cajasPorPaleta_Id}>{cajasPorPaleta.cantidad}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.cajasPorPaleta_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="finca">
                                        <FormattedMessage id='Finca' />
                                    </Label>
                                    <FormattedMessage id='Finca'>
                                        {(placeholder) =>
                                            <Input
                                                id="finca"
                                                name="finca"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleChange}
                                                value={this.state.model.finca}
                                                //valid={this.getValidationValue(this.state.modelValidation.finca)}
                                                //invalid={!this.getValidationValue(this.state.modelValidation.finca)}
                                            />
                                        }
                                    </FormattedMessage>
                                    {/*<FormFeedback>*/}
                                    {/*    {this.state.model.finca == '' ? <FormattedMessage id='Este campo es requerido' /> : ''}*/}
                                    {/*</FormFeedback>*/}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="fechaDeCosecha">
                                        <FormattedMessage id='Fecha de cosecha' />
                                    </Label>
                                    <FormattedMessage id='FechaDeCosecha'>
                                        {(placeholder) =>
                                            <Input
                                                id="fechaDeCosecha"
                                                name="fechaDeCosecha"
                                                //placeholder={placeholder}
                                                type="date"
                                                onChange={this.handleChange}
                                                value={this.state.model.fechaDeCosecha}
                                                valid={this.getValidationValue(this.state.modelValidation.fechaDeCosecha)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.fechaDeCosecha)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.fechaDeCosecha == '' ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="fechaDeEmpaque">
                                        <FormattedMessage id='Fecha de empaque' />
                                    </Label>
                                    <FormattedMessage id='FechaDeEmpaque'>
                                        {(placeholder) =>
                                            <Input
                                                id="fechaDeEmpaque"
                                                name="fechaDeEmpaque"
                                                //placeholder={placeholder}
                                                type="date"
                                                onChange={this.handleChange}
                                                value={this.state.model.fechaDeEmpaque}
                                                valid={this.getValidationValue(this.state.modelValidation.fechaDeEmpaque)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.fechaDeEmpaque)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.fechaDeEmpaque == '' ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label for="codigoTMU">
                                        <FormattedMessage id='Código TMU' />
                                    </Label>
                                    <FormattedMessage id='CodigoTMU'>
                                        {(placeholder) =>
                                            <Input
                                                ref={this.inputCodigoTMU}
                                                id="codigoTMU"
                                                name="codigoTMU"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleChange}
                                                onKeyDown={this._handleKeyDown}
                                                value={this.state.model.codigoTMU}
                                                valid={this.getValidationValue(this.state.modelValidation.codigoTMU)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.codigoTMU)}
                                                autoFocus 
                                                //pattern="/[0-9]+/"
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.codigoTMU == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Este codigo ya esta siendo usado' />}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="comentarios">
                                        <FormattedMessage id='Comentarios' />
                                    </Label>
                                    <FormattedMessage id='Comentarios'>
                                        {(placeholder) =>
                                            <Input
                                                id="comentarios"
                                                name="comentarios"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleChange}
                                                value={this.state.model.comentarios}
                                            />
                                        }
                                    </FormattedMessage>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <Button disabled={!this.state.modalIsValid} className="AddButtonIndex" onClick={() => {
                                    this.add_modal_guardar_onclick()
                                }}><AddIcon /> Agregar</Button>
                            </Col>
                            {/*<Col className="col-auto">*/}
                            {/*    <FormGroup>*/}
                            {/*        <IconButton size='small' className='SearchButton IndexButton' onClick={this.populateData}>*/}
                            {/*            <SearchIcon />*/}
                            {/*        </IconButton>*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="CleanButton IndexButton" onClick={this.clean_onclick}>
                                        <CachedOutlinedIcon fontSize='large' /> <FormattedMessage id='Limpiar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Row>
                <hr />
                <Row>
                    <PaletizadosTable data={this.state.data} add_onclick={this.add_onclick} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick} />
                </Row>
                <Modal size="lg" isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal size="md" isOpen={this.state.errorModalsate} toggle={this.errorModalToggle}>
                    <ModalHeader toggle={this.errorModalToggle}>
                        Error
                    </ModalHeader>
                    <ModalBody>
                        {this.state.errorModalText}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.errorModalToggle}>
                            Cerrar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let breadcrumbsData = this.state.loading
            ? <p></p>
            : <Breadcrumbs data={[
                { link: "/Semanas", message: "Semanas", active: true },
                { link: "/Semanas/" + this.state.contenedorSemanal.semana_Id + "/VaporesSemanalesProveedor", message: "Vapores", active: true },
                { link: "/VaporesSemanales/" + this.state.contenedorSemanal.vaporSemanalProveedor_Id + "/ContenedoresSemanales", message: "Contenedores", active: true },
                { link: "/ContenedoresSemanales/" + this.state.contenedorSemanal.contenedorSemanal_Id + "/Paletizados", message: "Paletizados", active: false },
            ]} />;

        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div>
                <h2><FormattedMessage id='IngresoDePaletas' /></h2>
                {breadcrumbsData}
                
                <div className="viewContainerHeader ">
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Semana' />: {this.state.contenedorSemanal.semana}</div>
                        <div className="px-4 py-2"><FormattedMessage id='Naviera' />: {this.state.contenedorSemanal.naviera}</div>
                        <div className="px-4 py-2"><FormattedMessage id='Barco' />: {this.state.contenedorSemanal.barco}</div>
                        <div className="px-4 py-2"><FormattedMessage id='Viaje' />: {this.state.contenedorSemanal.viaje}</div>
                    </div>
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Destino' />: {this.state.contenedorSemanal.destino}</div>
                        <div className="px-4 py-2"><FormattedMessage id='Contenedor' />: {this.state.contenedorSemanal.contenedor}</div>
                        <div className="px-4 py-2"><FormattedMessage id='EtiquetaEspecial' />: {this.state.contenedorSemanal.etiquetaEspecial}</div>
                    </div>


                </div>
                <div className="viewContainer-lg">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({
            loading: true,
            contenedorSemanal: await this.load_contenedorSemanal(),
            etiquetasCore: await this.load_etiquetasCore(),
            calibres: await this.load_calibres(),
            cajasPorPaleta: await this.load_cajasPorPaleta(),
            contenedores: await this.load_contenedores()
        }, async () => {
            const token = await authService.getAccessToken();
            var queryString = '?contenedorSemanal_Id=' + this.state.contenedorSemanal.contenedorSemanal_Id + '&';
            //Object.keys(this.state.model).forEach(key => {
            //    queryString += key + "=" + this.state.model[key] + "&";
            //});
            queryString = queryString.slice(0, -1);
            const response = await fetch('api/paletizados' + queryString, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            });
            const responceData = await response.json();
            this.setState({ data: responceData, loading: false });

        });
    }

    async handleChange(event) {

        var model = this.state.model;
        model[event.target.name] = event.target.value;
        if (event.target.name == "etiquetaCore_Id") {
            var etiquetaCore = this.state.etiquetasCore.find(x => x.etiquetaCore_Id == event.target.value);
            if (etiquetaCore) {
                model["carton"] = etiquetaCore.carton;
                model["colilla"] = etiquetaCore.colilla;
            } else {
                model["carton"] = "";
                model["colilla"] = "";
            }

        }
        //else if (event.target.name == "codigoTMU") {
        //    // Remove non-numeric characters
        //    var numericValue = event.target.value.replace(/\D/g, '');

        //    // Ensure the value is an integer with no leading zeros
        //    var integerValue = parseInt(numericValue, 10);

        //    // Limit the length to a maximum of 10 characters

        //    model[event.target.name] = isNaN(integerValue) ? "" : integerValue.toString().slice(0, 10)
        //}
        
        this.setState({ model: model}, async () => {
            this.validate()
        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><PaletizadosView contenedorSemanal={this.state.contenedorSemanal} operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState}></PaletizadosView></div>);
        //return (<div><PaletizadosView ref={this.modalBodyState}></PaletizadosView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/paletizados', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            //this.modalToggle();
            //await this.populateData()
            var model = this.state.model;
            model.codigoTMU = "";
            await this.setState({
                loading: true,
                model: model,
                //contenedorSemanal: await this.load_contenedorSemanal(),
                //etiquetasCore: await this.load_etiquetasCore(),
                //calibres: await this.load_calibres(),
                //cajasPorPaleta: await this.load_cajasPorPaleta(),
                //contenedores: await this.load_contenedores()
            }, async () => {
                const token = await authService.getAccessToken();
                var queryString = '?contenedorSemanal_Id=' + this.state.contenedorSemanal.contenedorSemanal_Id + '&';
                //Object.keys(this.state.model).forEach(key => {
                //    queryString += key + "=" + this.state.model[key] + "&";
                //});
                queryString = queryString.slice(0, -1);
                const response = await fetch('api/paletizados' + queryString, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
                });
                const responceData = await response.json();
                this.setState({ data: responceData, loading: false }, async () => {
                    await this.validate();
                    this.inputCodigoTMU.current.focus();
                });
            });
        }
        else {
            var error = await response.text();
            this.setState({
                errorModalText: error,
                errorModalsate: true, 
                loading: false
            }, async () => {
            });
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paletizados/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><PaletizadosView contenedorSemanal={this.state.contenedorSemanal} operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState} data={responceData}></PaletizadosView></div>);
        //return (<div><PaletizadosView ref={this.modalBodyState}></PaletizadosView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/paletizados/' + this.modalBodyState.paletizado_Id, {
            method: 'PUT',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paletizados/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><PaletizadosDelete setModalBodyState={this.setModalBodyState} data={responceData}></PaletizadosDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paletizados/' + this.modalBodyState.paletizado_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        var model = {
            ...this.state.model,
            etiquetaCore_Id: 0,
            calibre_Id: 0,
            cajasPorPaleta_Id: 0,
            carton: "",
            colilla: "",
            fechaDeCosecha: new Date().toISOString().substring(0, 10),
            fechaDeEmpaque: new Date().toISOString().substring(0, 10),
            codigoTMU: "",
            comentarios: "",
            finca: "",
        };
        this.setState({
            model: model
        },
            await this.validate()
        );
        
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            console.log("state.modelValidation", state.modelValidation)
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
    async load_contenedorSemanal() {
        var rawUrl = window.location.toString();
        var contenedorSemanal_Id = rawUrl.split("ContenedoresSemanales/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/contenedoresSemanales/' + contenedorSemanal_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_etiquetasCore() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/etiquetasCore?habilitado=true', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_calibres() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/calibres/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_cajasPorPaleta() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/cajasPorPaleta/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_contenedores() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/contenedores', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }

    async _handleKeyDown(e) {
        if (e.key === 'Enter') {
            if (this.state.modalIsValid) {
                this.add_modal_guardar_onclick()
            }
        }
    }
}